import { certifications } from "@/data";

const WhyChooseUs = () => {
  return (
    <section className="why section" id="why">
      <div className="container">
        <div className="why__head">
          <span className="badge"><span className="badge__dot" />Why choose us</span>
          <h2 className="why__title">More Than a Travel Company. A Trusted, Certified Global Partner</h2>
        </div>
        <div className="why__cards">
          {certifications.map((c) => (
            <article className="cert-card" key={c.title} style={{ "--rot": `${c.rotate}deg` }}>
              <img className="cert-card__img" src={c.image} alt={c.title} loading="lazy" />
              <h3 className="cert-card__title">{c.title}</h3>
              <p className="cert-card__desc">{c.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
